// AoT requires an exported function for factories
import { HttpBackend } from '@angular/common/http';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';

export function HttpLoaderFactory(http: HttpBackend) {
    return new MultiTranslateHttpLoader(http, [
        // host app i18n assets
        { prefix: './assets/i18n/', suffix: '.json' },
        // dsw lib assets
        {
            prefix: 'https://api.viessmann.com/translations/v2/phraseapp-proxy/projects/ec38b083a23c58c604a49d7f443dd7f2/locales/',
            suffix: '/download?file_format=simple_json'
        }
    ]);
}
